module.exports = __webpack_public_path__ + "img/09.7c710b18.jpg";